// extracted by mini-css-extract-plugin
export default {"itemsContainer":"Header_itemsContainer__4h9t3","image":"Header_image__U2PO8"};